"use client";
import { createContext, useContext, useState, useCallback, useEffect } from "react";

const AuthContext = createContext();

function getBuyerInfoFromStorage() {
  if (typeof window === "undefined") return { accelerator_value: 0, signals_generated: 0 };
  const capital = localStorage.getItem("accelerator_capital");
  return {
    name: "Usuario",
    accelerator_value: capital ? parseInt(capital, 10) : 0,
    signals_generated: 0,
    is_vip: false,
    last_signal_at: null,
  };
}

export function AuthProvider({ children }) {
  const [loading] = useState(false);
  const [buyerInfo, setBuyerInfo] = useState(() => ({ name: "Usuario", accelerator_value: 0, signals_generated: 0, is_vip: false, last_signal_at: null }));

  useEffect(() => {
    setBuyerInfo(getBuyerInfoFromStorage());
  }, []);
  const user = { email: "", user_metadata: { name: "Usuario" } };

  const logout = () => {
    // App aberto - logout não faz nada
  };

  const refreshBuyerInfo = useCallback(async () => {
    const info = getBuyerInfoFromStorage();
    setBuyerInfo(info);
    return info;
  }, []);

  const value = {
    user,
    buyerInfo,
    loading,
    logout,
    refreshBuyerInfo,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth deve ser usado dentro de um AuthProvider");
  }
  return context;
}
